import { render, staticRenderFns } from "./DocumentTypeLabel.vue?vue&type=template&id=5b24858f&"
import script from "./DocumentTypeLabel.vue?vue&type=script&lang=js&"
export * from "./DocumentTypeLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports